import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
interface BlogSidebarProps {
  onJoinClick?: () => void;
}
export function BlogSidebar({
  onJoinClick
}: BlogSidebarProps) {
  return <aside className="hidden lg:block" data-id="element-98">
      <div className="sticky top-32" data-id="element-99">
        {/* Priority List CTA Card */}
        <div className="bg-[#1A7B7E] rounded-2xl p-6 text-white shadow-lg overflow-hidden relative" data-id="element-100">
          <div className="absolute top-0 right-0 -mr-10 -mt-10 w-32 h-32 bg-white opacity-10 rounded-full blur-2xl" aria-hidden="true" data-id="element-101"></div>

          <div className="relative z-10" data-id="element-102">
            <h3 className="text-2xl font-bold mb-3" data-id="element-103">Join the Priority List</h3>
            <p className="text-sm text-gray-100 mb-4 leading-relaxed" data-id="element-104">
              Get early access and exclusive benefits when we launch.
            </p>

            <ul className="space-y-2 mb-6" data-id="element-105">
              <li className="flex items-start gap-2 text-sm" data-id="element-106">
                <Check className="h-4 w-4 mt-0.5 flex-shrink-0 text-[#FFC107]" data-id="element-107" />
                <span data-id="element-108">Priority access to storage bays</span>
              </li>
              <li className="flex items-start gap-2 text-sm" data-id="element-109">
                <Check className="h-4 w-4 mt-0.5 flex-shrink-0 text-[#FFC107]" data-id="element-110" />
                <span data-id="element-111">Exclusive early bird pricing</span>
              </li>
              <li className="flex items-start gap-2 text-sm" data-id="element-112">
                <Check className="h-4 w-4 mt-0.5 flex-shrink-0 text-[#FFC107]" data-id="element-113" />
                <span data-id="element-114">No commitment required</span>
              </li>
            </ul>

            <Button variant="secondary" className="w-full bg-[#FFC107] text-black hover:bg-[#FFD54F] border-none shadow-md font-bold" onClick={onJoinClick} data-id="element-115">
              Register Interest
            </Button>
          </div>
        </div>
      </div>
    </aside>;
}